import { getAreaTreeNodeById, isJumpNextLevel } from './store'

// 级别对应的统称
export const BREAD_LEVL_MAP = {
  1: '大区',
  2: '省/直辖市',
  3: '城市',
  4: '区/县',
  5: '镇/街道',
}

export function createBreadCrumbData (item) {
  const { parents = [] } = item || {}
  // 前两级不展示，这里应该去配置。或者在数据层做处理。
  const breadCrumbData = parents.reduce((acc, ele) => {
    const flatTreeNode = getAreaTreeNodeById(ele.districtID)
    const { parentId, level, shortName } = flatTreeNode || {}
    // 如果当前节点的父级是存在 需要跳过的场景。则不展示
    const parentNode = getAreaTreeNodeById(parentId)
    const isHidden = isJumpNextLevel(parentNode)
    // 级别大于1即（区间不展示）&& 存在简称 && 父级不是虚拟的节点（类似天津、北京、上海等无市区或区县的节点）
    if (+level > 1 && shortName && !isHidden) {
      acc.push(ele)
    }
    return acc
  }, [])
  const breadCrumbLabel = BREAD_LEVL_MAP[parents.length] || BREAD_LEVL_MAP['2']
  return {
    breadCrumbData,
    breadCrumbLabel
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/data/bread-crumb.js